import { Box, Drawer, Icon, Stack } from "@mui/material";
import { DrawerProps } from "@mui/material";
import trans from "helpers/trans";
import PropTypes from "prop-types";
import LoadingButton from "../Button/LoadingButton";

interface IGPUnsave extends Omit<DrawerProps, "onSubmit"> {
    loading: boolean;
    onSubmit: (event: any, force?: boolean) => void;
    saveText?: string;
    renderUnsavedActions?: any;
}

function GPUnsave({
    loading,
    onSubmit,
    renderUnsavedActions,
    saveText,
}: IGPUnsave) {
    return (
        <Drawer
            anchor="top"
            open
            variant="permanent"
            sx={{
                "& .MuiDrawer-paper": {
                    padding: (theme) => theme.spacing(0, 2),
                    zIndex: (theme) => theme.zIndex.drawer + 2,
                },
            }}
        >
            <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
                gap={1}
                sx={{ height: 64 }}
            >
                <Box flex={1}></Box>
                {renderUnsavedActions?.()}
                <LoadingButton
                    loading={loading}
                    onClick={onSubmit}
                    startIcon={<Icon>save</Icon>}
                    type="submit"
                >
                    {saveText ? saveText : trans("global.button.save")}
                </LoadingButton>
            </Stack>
        </Drawer>
    );
}

GPUnsave.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default GPUnsave;
